import React from 'react';
import { Label, Palette, Variant, } from '@havenengineering/module-shared-library/dist/components/Label';
import styles from './Let2offsetApplicationCard.module.scss';
import { Button } from '../Button';
import Alert from '../../v2/components/Alert';
export const Let2offsetApplicationCard = ({ isRenewing = false, handleContinueWithRenewal, handleLetToOwnRenewal, setOpenLet2OwnWarningModal, }) => {
    return (<div className={styles.let2offsetApplicationCard}>
      {isRenewing && (<Label variant={Variant.SOLID} palette={Palette.VIDID_ORANGE} text='In progress'/>)}
      <p className={styles.heading}>Let2offset renewal</p>
      <p>
        You’ll just need to add breaks and confirm your Direct Debit details to continue with
        Let2offset for another year.
      </p>
      {isRenewing && (<Alert title='Break selection not saved' severity='warning' text='Please complete your Let2offset renewal to confirm your chosen breaks.'/>)}
      <div className={styles.buttonContainer}>
        {isRenewing ? (<Button type='button' includeChevron onClick={() => handleContinueWithRenewal()} data-testid='banner-let2own-continue'>
            Continue with renewal
          </Button>) : (<>
            <Button type='button' includeChevron onClick={() => handleLetToOwnRenewal()} data-testid='banner-let2own-add-breaks'>
              Renew now
            </Button>
            <Button variant='text' onClick={() => setOpenLet2OwnWarningModal(true)} data-testid='banner-let2own-cancel' includeChevron className={styles.buttonWhite}>
              See other letting options
            </Button>
          </>)}
      </div>
    </div>);
};
